import { Component, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem, SortEvent } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { GlobalMessage } from '../../utility/modals';
import { Utilityservice } from '../../utility/utilityservice.service';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { ApplicationlogsService } from './applicationlogs.service';
import moment from 'moment';
import { ErrorlogmodalComponent } from '../../directives/errorlogmodal/errorlogmodal.component';
import * as Highcharts from 'highcharts';
import HeatmapModule from 'highcharts/modules/heatmap';

HeatmapModule(Highcharts);
@Component({
  selector: 'app-applicationlogs',
  templateUrl: './applicationlogs.component.html',
  styleUrls: ['./applicationlogs.component.css']
})
export class ApplicationlogsComponent {
  @ViewChild('dt') dt: any;
  @ViewChild('topErrorDt') topErrorDt: any;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  visible: boolean = false;
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  downloadformate = false;
  position = 'top';
  currentPageIndex: number = 0;
  rowsize: number = 10;
  cols = [];
  tablecount: number = 0;
  message: GlobalMessage = new GlobalMessage()
  _selectedColumns = [];
  filterinput = new Filterreq()
  searchTerm: string = '';
  today: Date;
  todateerrorDIsplay = false;
  fromdateerrorDisplay = false;
  errorDIsplay = false;
  showCloseModal = false;
  closeRemarks = '';
  confirmClose = false;
  remarksError = false;
  CSRFToken = '';
  selectedRow: any;
  showClosureDetailsModal = false;
  selectedLogStatus: string = '0';
  showOccurrencesModal = false;
  occurrenceData: any[] = [];
  topErrorSummary: any[] = [];
  showStatusHint = true;
  topErrorSearchTerm = '';
  showSummaryCards = false;
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  productChartOptions: Highcharts.Options = {};
  statusChartOptions: Highcharts.Options = {};
  heatMapOptions: Highcharts.Options = {};
  dailyTrendOptions: Highcharts.Options = {};
  openLogsByProduct: Highcharts.Options = {};
  errorAgeChartOptions: Highcharts.Options = {};
  randomInsight: any = {};
  selectedDate = "";
  reminderData: any[] = [];
  isSendingReminder = false;
  allowSendingEmail: number | null = null;
  selectedHour: number;
  showEmailConfig: boolean = false;
  techUsers: any[] = [];
  selectedTechUsers: string[] = [];
  selectedLogId: any = null;
  sendReminderUserList: string[] = [
    "3", "7", "10", "480", "15742", "11", "15", "488", "479", "12394"
  ];
  loggedInUserId = "";
  allowReminders = "N";
  activityFilter: string = 'ALL'; 
  activityFeed: ActivityFeedItem[] = [];
  activityFeedLoading = false;
  todayFeed: Date = new Date();
  activityFeedDate: Date = new Date(this.todayFeed);

  private hintTimer: any;
  constructor(public router: Router, public dialogService: DialogService,
    private appLogService: ApplicationlogsService, private utilityservice: Utilityservice,
    private spinner: NgxSpinnerService) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text;
    this.today = new Date();
    this.loggedInUserId = this.utilityservice.getLoggeduser()?.userid;
    if (this.sendReminderUserList.includes(String(this.loggedInUserId))) {
      this.allowReminders = "Y";
    }
  }

  dashboardView: 'table' | 'analytics' = 'table';

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight()
    this.getgriddata();
    //this.dynamiccols();
    this.getDropdownList();
    this.getSummaryCards();
    this.loadTopErrorSummary();
    this.loadDashboardCharts();
    this.updateWeekRange(false);
    this.getRandomInsight();
    this.loadActivityFeed();
    //   setTimeout(() => {
    //   this.showStatusHint = false;
    // }, 5000);
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }
  dynamiccols() {
    this.cols = [
      { field: 'id', header: 'Id', type: 'text', sort: true, filter: true, width: '40px', isChecked: true, class: 'headerid' },
      { field: 'organisation', header: 'Organisation', type: 'text', sort: true, filter: true, width: '180px', isChecked: true, class: 'otherheader' },
      { field: 'userName', header: 'User/Email', type: 'text', sort: true, filter: true, width: '220px', isChecked: true, class: 'otherheader' },
      { field: 'productinitial', header: 'Product', type: 'text', sort: true, filter: true, width: '120px', isChecked: true, class: 'otherheader' },
      { field: 'page', header: 'Page', type: 'text', sort: true, filter: true, width: '140px', isChecked: true, class: 'otherheader' },
      { field: 'methodName', header: 'API', type: 'text', sort: true, filter: true, width: '180px', isChecked: true, class: 'otherheader' },
      { field: 'logData', header: 'Data', type: 'text', sort: true, filter: true, width: '400px', isChecked: true, class: 'otherheader' },
      { field: 'createdAt', header: 'Logged On', type: 'text', sort: true, filter: true, width: '170px', isChecked: true, class: 'otherheader' }
    ];

    if (this.selectedLogStatus == '1' || this.selectedLogStatus == '-1') {
      this.cols.push(
        { field: 'closedBy', header: 'Closed By', type: 'text', sort: true, filter: true, width: '180px', isChecked: true, class: 'otherheader' },
        { field: 'closureRemarks', header: 'Closure Remarks', type: 'text', sort: true, filter: true, width: '180px', isChecked: true, class: 'otherheader' },
        { field: 'closedOn', header: 'Closed On', type: 'text', sort: true, filter: true, width: '170px', isChecked: true, class: 'otherheader' }
      );
    }
    this._selectedColumns = this.cols;
  }

  topErrorCols = [
    { field: 'productInitial', header: 'Product', width: '120px', isChecked: true, class: 'otherheader' },
    { field: 'page', header: 'Page', width: '220px', isChecked: true, class: 'otherheader' },
    { field: 'methodName', header: 'API', width: '220px', isChecked: true, class: 'otherheader' },
    { field: 'openCount', header: 'Open', width: '90px', isChecked: true, class: 'otherheader' },
    { field: 'closedCount', header: 'Closed', width: '90px', isChecked: true, class: 'otherheader' },
    { field: 'totalOccurrences', header: 'Total', width: '90px', isChecked: true, class: 'otherheader' },
    { field: 'lastOccurrence', header: 'Last Seen', width: '90px', isChecked: true, class: 'otherheader' },

  ];

  _selectedTopErrorCols = [...this.topErrorCols];



  showDialog() {
    const payload: any = {};
    if (this.selectedProduct) {
      payload.productId = this.selectedProduct;
    }

    if (this.selectedOrganisation) {
      payload.orgId = this.selectedOrganisation;
    }
    if (this.filtersData['tfromdate']) {
      payload.fromDate = this.filtersData['tfromdate'];
    }

    if (this.filtersData['ttodate']) {
      payload.toDate = this.filtersData['ttodate'];
    }
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname: "Error_Logs.xlsx", downloadapi: 'common/applicationlogs/exceldownload', method: 'post', message: this.excel_paragraph, payload: payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });
  }

  lastInsertedId: number | null = null;
  getgriddata() {

    const payload: any = {};
    const currentPageSize = this.rowsize;


    if (this.selectedLogStatus != null && this.selectedLogStatus !== '') {
      payload.logStatus = this.selectedLogStatus;
    }

    if (this.selectedProduct) {
      payload.productId = this.selectedProduct;
    }

    if (this.selectedOrganisation) {
      payload.orgId = this.selectedOrganisation;
    }

    if (this.selectedClosedBy) {
      payload.closedBy = this.selectedClosedBy;
    }


    if (this.filtersData['tfromdate']) {
      payload.fromDate = this.filtersData['tfromdate'];
    }

    if (this.filtersData['ttodate']) {
      payload.toDate = this.filtersData['ttodate'];
    }

    Object.keys(payload).forEach(key => {
      const val = payload[key];
      if (val === '' || val == null) {
        delete payload[key];
      }
    });

    this.dynamiccols();
    this.appLogService.getgrid(payload).subscribe({

      next: (data: any) => {
        this.lastInsertedId = data.lastInsertedId;
        this.tableData = (data.confdata || []).map(item => ({
          ...item,
          isSelect: false
        }));

        this.tablecount = data.totalcount || this.tableData.length;

        this.options = this.utilityservice.getOptionDropdown(this.tablecount);

        this.paginatorArray = this.options.map(e => e.value);

        if (!this.paginatorArray.includes(this.rowsize)) {
          this.paginatorArray.push(this.rowsize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.totalRecords = this.tablecount;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);

      },
      error: (error) => {
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      }
    });
  }

  modalHeight = "100%";
  modalWidth = "90vw";


  downloadgridexcel() {
    this.appLogService.exceldownload().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Application_Configuration_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }


  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      // Handling null values
      if (value1 == null && value2 != null) return -1;
      if (value1 != null && value2 == null) return 1;
      if (value1 == null && value2 == null) return 0;

      // Check if the field is createdon for date comparison
      if (event.field === 'createdon') {
        // Parse the date strings to Date objects
        const date1 = new Date(value1);
        const date2 = new Date(value2);
        return date1.getTime() - date2.getTime(); // Sort by timestamp
      }

      // Handle string comparisons
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
      }

      // Fallback to default number comparison for other types
      return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
    });

    return event.order === -1 ? event.data.reverse() : event.data; // Reverse if descending
  }


  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
  getRowClass(rowData: any): string {
    const type = rowData?.logType?.toUpperCase();
    const isClosed = Number(rowData?.isClosed);

    if (type === 'E' && isClosed === 0) {
      return 'log-error-open';
    }

    if (type === 'E' && isClosed === 1) {
      return 'log-error-closed';
    }

    return '';
  }

  filterProductData: Array<any> = [];
  filterOrgData: Array<any> = [];
  filterClosedByData: Array<any> = [];

  selectedProduct: any = null;
  selectedOrganisation: any = null;
  selectedClosedBy: any = null;
  filtersData = {
    tproduct: '',
    torg: '',
    tclosedby: '',
    page: 1,
    size: 10,
  }

  getProductTooltip(): string {

    const selected = this.filterProductData.find(
      item => item["productId"] === this.selectedProduct
    );
    return selected ? selected["productId"] : 'Select Product';
  }
  getDropdownList() {
    const payload: any = {};

    if (this.filtersData['tfromdate']) {
      payload.fromDate = this.filtersData['tfromdate'];
    }

    if (this.filtersData['ttodate']) {
      payload.toDate = this.filtersData['ttodate'];
    }
    if (this.filtersData['tproduct']) {
      payload.productId = this.filtersData['tproduct'];
    }

    if (this.filtersData['torg']) {
      payload.orgId = this.filtersData['torg'];
    }

    if (this.filtersData['tclosedby']) {
      payload.closedBy = this.filtersData['tclosedby'];
    }

    const products = this.appLogService.getproductfilter(payload);
    products.subscribe(res => {
      this.filterProductData = res;
      this.filterProductData.unshift({ productid: '', productinitial: 'Select Product' });
    });

    const organisation = this.appLogService.getorgfilter(payload);
    organisation.subscribe(res => {
      this.filterOrgData = res;
      this.filterOrgData.unshift({ orgId: '', orgname: 'Select Organisation' });
    });

    const closedby = this.appLogService.getclosedbyfilter(payload);
    closedby.subscribe(res => {
      this.filterClosedByData = res;
      this.filterClosedByData.unshift({ userid: '', userName: 'Select User' });
    });
  }


  getParams2(event, label) {
    this.errorAgeView = 'day';
    this.weekTrendRange = "Last 7 Days";
    if (label == 'Product Row') {
      this.filtersData['tproduct'] = event.value;
      this.selectedProduct = event.value;
    }

    if (label == 'Org Row') {
      this.filtersData['torg'] = event.value;
      this.selectedOrganisation = event.value;
    }

    if (label == 'From Date') {
      this.filtersData['tfromdate'] = event.value;
    }

    if (label == 'To Date') {
      this.filtersData['ttodate'] = event.value;
    }

    if (label == 'Log Status') {
      this.selectedLogStatus = event.value;
      this.filtersData['logStatus'] = event.value;
    }

    if (label == 'Closed By Row') {
      this.selectedClosedBy = event.value;
      this.filtersData['tclosedby'] = event.value;
    }
    this.getDropdownList();
    this.getgriddata();
    this.loadDashboardCharts();
  }

  onDateChange(): void {
    this.filterinput.fromdate = this.filterinput.fromdate ? this.filterinput.fromdate : null;
    this.filterinput.todate = this.filterinput.todate ? this.filterinput.todate : null;

    if (this.filterinput.fromdate && this.filterinput.todate) {
      this.filtersData['tfromdate'] = moment(this.filterinput.fromdate).format('YYYY-MM-DD');
      this.filtersData['ttodate'] = moment(this.filterinput.todate).format('YYYY-MM-DD');

      this.getDropdownList();
      this.getgriddata();
    } else {
      return;
    }
  }

  getdates(event) {
    this.fromdateerrorDisplay = false;
    this.todateerrorDIsplay = false;
    this.errorDIsplay = false;

    if (event.fromdate && !event.todate) {
      this.todateerrorDIsplay = true;
      return;
    }

    if (event.todate && !event.fromdate) {
      this.fromdateerrorDisplay = true;
      return;
    }


    if (event.fromdate <= event.todate) {
      this.errorDIsplay = false;

      this.filtersData['tfromdate'] =
        moment(event.fromdate).format('YYYY-MM-DD');

      this.filtersData['ttodate'] =
        moment(event.todate).format('YYYY-MM-DD');

    } else {
      this.errorDIsplay = true;
    }
    this.getDropdownList();
    this.getgriddata();
    this.loadDashboardCharts();
  }
  onclear(event) {
    this.fromdateerrorDisplay = false;
    this.todateerrorDIsplay = false;
    if (event.todate == null || event.fromdate == null) {
      this.errorDIsplay = false;
      this.filtersData['tfromdate'] = ''; this.filtersData['ttodate'] = '';
    }

    if (!event.fromdate && event.todate) {
      this.fromdateerrorDisplay = true;

      this.filtersData['fromdate'] = '';
    }
    if (!event.todate && event.fromdate) {
      this.todateerrorDIsplay = true;

      this.filtersData['todate'] = '';
    }

  }

  refreshFilters() {
    this.spinner.show();
    this.weekOffset = 0;
    this.weekTrendOffset = 0;
    this.selectedProduct = '';
    this.selectedOrganisation = '';
    this.selectedLogStatus = '0';
    this.filterinput.fromdate = null;
    this.filterinput.todate = null;
    this.filtersData['tfromdate'] = '';
    this.filtersData['ttodate'] = '';
    this.filtersData['tproduct'] = '';
    this.filtersData['torg'] = '';
    this.filtersData['tclosedby'] = '';
    this.selectedClosedBy = '';
    this.getDropdownList();
    this.errorDIsplay = false;
    this.todateerrorDIsplay = false;
    this.fromdateerrorDisplay = false;
    this.getgriddata();
    this.getSummaryCards();
    this.loadTopErrorSummary();
    this.loadDashboardCharts();
    this.updateWeekRange();
    this.errorAgeView = 'day';
    this.weekTrendRange = "Last 7 Days";
    this.spinner.hide();
  }

  openCloseModal(row: any) {
    this.selectedRow = row;
    this.showCloseModal = true;
    this.closeRemarks = '';
    this.confirmClose = false;
    this.remarksError = false;
    this.gettoken();
  }

  onlyView: boolean;
  isClose: boolean;
  viewClosureData: boolean;
  viewMode: "";
  show(title, data) {
    if (title === "Close Error Log" || title === "Last Log"
    ) {
      this.onlyView = false;
      this.viewClosureData = false;
      this.isClose = true;
      if(data.isClosed == 1){ // from activity feed click
        this.onlyView = true;
        this.isClose = false;
        this.viewClosureData = false;
      }
    }
    if (title === "Closure Data") { 
      this.onlyView = true;
      this.isClose = false;
      this.viewClosureData = false;
    }
    if (title === "View Closure Data") {
      this.viewClosureData = true;
    }

    if (title === "Closure Data" || title === "Close Error Log") {
      this.appLogService.getDataByid(data.id).subscribe(res => {

        const details = res;

        this.ref = this.dialogService.open(ErrorlogmodalComponent, {
          header: title,
          width: '90%',
          data: {
            title: title,
            selectedRow: details,
            onlyView: this.onlyView,
            isClose: this.isClose,
            viewMode: '',
            isViewClosureData: this.viewClosureData,
            logId: data.id
          }
        });
        this.ref.onClose.subscribe(() => {
          if(title != "Closure Data"){
            this.getgriddata();
            this.getSummaryCards();
            this.loadTopErrorSummary();
            this.loadDashboardCharts();
            this.loadActivityFeed();
          }
        });

      });
    }
    else if (title === "Last Log") {
      if (this.lastInsertedId == 0) {
        return;
      }
      this.appLogService.getDataByid(this.lastInsertedId).subscribe(res => {
        const details = res;
        this.ref = this.dialogService.open(ErrorlogmodalComponent, {
          header: title,
          width: '70%',
          data: {
            title: title,
            selectedRow: details,
            onlyView: this.onlyView,
            isClose: this.isClose,
            viewMode: '',
            isViewClosureData: this.viewClosureData
          }
        });

        this.ref.onClose.subscribe(() => {
          this.getgriddata();
          this.getSummaryCards();
          this.loadTopErrorSummary();
          this.loadDashboardCharts();
          this.loadActivityFeed();
        });

      });
    }
    else if (title === "Open Logs" || title === "Closed Logs" || title === "Top API"
      || title === "Most Affected Page" || title === "Todays Logs" || title === "Most Affected Product"
      || title == "Product with Highest Open Logs" || title == "Todays Closed Logs" || title == "Todays Open Logs"
      || title == "Current Week Logs" || title == "Error Age Data" || title == "Open Errors by Product" || title == "Weekly Trend"
      || title == "Heat Map"
    ) {
      if (title === 'Top API' && this.summaryCards.topFailingApi == "") {
        return;
      }
      if (title === 'Product with Highest Open Logs' && this.summaryCards.productWithHighestOpenLog == "") {
        return;
      }
      if (title === "Most Affected Product" && this.summaryCards.mostAffectedProduct == "") {
        return;
      }
      if (title === 'Most Affected Page' && this.summaryCards.mostAffectedPage == "") {
        return;
      }
      if (title === 'Todays Logs' && this.summaryCards.todaysLogs == "0") {
        return;
      }
      if (title === 'Todays Closed Logs' && this.summaryCards.todayClosedLogs == "0") {
        return;
      }
      if (title === 'Todays Open Logs' && this.summaryCards.todayOpenLogs == "0") {
        return;
      }
      if (title === 'Current Week Logs' && this.summaryCards.thisWeekLogs == "0") {
        return;
      }


      this.ref = this.dialogService.open(ErrorlogmodalComponent, {
        header: title,
        width: '80%',
        data: {
          title: title,
          viewMode: title,
          isViewClosureData: false,
          onlyView: false,
          isClose: false,
          ...(title === 'Open Errors by Product' && {
            productId: data.productId,
            orgId: this.selectedOrganisation,
            fromDate: data.fromDate,
            toDate: data.toDate

          }),
          ...(title === 'Error Age Data' && {
            errorAge: data.errorAge,
            productId: this.selectedProduct,
            orgId: this.selectedOrganisation,
            logStatus: this.selectedLogStatus,

          }),
          ...(title === 'Weekly Trend' && {
            productId: this.selectedProduct,
            orgId: this.selectedOrganisation,
            selectedDate: this.selectedDate,

          }),
          ...(title === 'Heat Map' && {
            productId: this.selectedProduct,
            orgId: this.selectedOrganisation,
            selectedDate: this.selectedDate,
            selectedHour: this.selectedHour

          })
        }
      });

      this.ref.onClose.subscribe(() => {
        this.getgriddata();
        if (title === "Open Logs" || title === "Top API" || title === 'Most Affected Page'
          || title === "Todays Logs" || title === "Most Affected Product"
          || title == "Product with Highest Open Logs" || title == "Todays Open Logs"
          || title == "Current Week Logs" || title == "Error Age Data" || title == "Open Errors by Product"
          || title == "Heat Map"
        ) {
          this.getSummaryCards();
          this.getgriddata();
          this.loadTopErrorSummary();
          //this.loadDashboardCharts();
        }
      });

    }
    else {
      this.ref = this.dialogService.open(ErrorlogmodalComponent, {
        header: title,
        width: '90%',
        data: {
          title: title,
          viewMode: '',
          pageName: data.page,
          methodName: data.methodName,
          isViewClosureData: this.viewClosureData
        }
      });
      this.ref.onClose.subscribe(() => {
        this.getgriddata();
        this.getSummaryCards();
        this.loadTopErrorSummary();
      });
    }
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }

  viewClosureDetails(row: any) {
    this.selectedRow = row;
    this.showClosureDetailsModal = true;
  }

  logStatusOption: Array<any> = [
    { label: 'Open', value: '0' },
    { label: 'Closed', value: '1' },
    { label: 'All', value: '-1' }
  ];

  viewErrorOccurrences(row: any) {
    this.selectedRow = row;

    const payload = {
      page: row.page,
      methodName: row.methodName
    };

    this.appLogService.getErrorOccurrences(payload).subscribe({
      next: (res: any) => {
        this.occurrenceData = res.data || [];
        this.showOccurrencesModal = true;
      },
      error: () => {
        Swal.fire('Error', 'Unable to fetch occurrences.', 'error');
      }
    });
  }

  showOccurrenceDetailsModal = false;
  selectedOccurrence: any;

  viewOccurrenceDetails(data: any) {
    this.selectedOccurrence = data;
    this.showOccurrenceDetailsModal = true;
  }
  summaryCards: any = {
    openLogs: 0,
    closedLogs: 0,
    topFailingApi: '-',
    mostAffectedPage: '-',
    lastLog: '',
    resolutionRate: '',
    thisWeekLogs: '',
    errorFreeStreak: ''
  }

  getSummaryCards() {
    this.appLogService.getSummaryCards().subscribe({
      next: (res: any) => {
        this.summaryCards = res;
      },
      error: () => {
        Swal.fire('Error', 'Unable to fetch cards.', 'error');
      }
    });

  }
  loadTopErrorSummary() {
    this.appLogService.getTopErrorSummary().subscribe({
      next: (data: any) => {
        this.topErrorSummary = data;
      }
    });
  }


  toggleSummaryCards() {
    this.showSummaryCards = !this.showSummaryCards;
    clearTimeout(this.hintTimer);
    if (this.showSummaryCards) {
      this.showStatusHint = true;

      this.hintTimer = setTimeout(() => {
        this.showStatusHint = false;
      }, 5000);
    } else {
      this.showStatusHint = false;
    }
  }

  switchDashboard(view: 'table' | 'analytics') {
    this.dashboardView = view;
  }


  loadDashboardCharts() {
    this.errorAgeView = 'day';
    const self = this;

    const payload: any = {};


    if (this.selectedProduct) {
      payload.productId = this.selectedProduct;
    }

    if (this.selectedOrganisation) {
      payload.orgId = this.selectedOrganisation;
    }

    if (this.selectedLogStatus != null && this.selectedLogStatus !== '') {
      payload.logStatus = this.selectedLogStatus;
    }

    if (this.filtersData['tfromdate']) {
      payload.fromDate = this.filtersData['tfromdate'];
    }

    if (this.filtersData['ttodate']) {
      payload.toDate = this.filtersData['ttodate'];
    }

    Object.keys(payload).forEach(key => {
      if (payload[key] === '' || payload[key] == null) {
        delete payload[key];
      }
    });

    this.appLogService.getDashboardCharts(payload).subscribe({
      next: (res: any) => {

        const trend = res.errorTrend;
        const products = res.productLogs;
        const status = res.logStatus[0];
        const heatData = res.sevenDayHeatMap;
        const dailyTrend = res.dailyOpenClosed;
        const openErrorsByProduct = res.openErrorsByProduct;
        const errorAge = res.errorAge;
        this.errorAgeChartOptions = {
          chart: {
            type: 'bar',
            height: 330
          },

          title: {
            text: ''
          },

          credits: {
            enabled: false
          },

          xAxis: {
            categories: errorAge.map(x => x.errorAge),
            lineWidth: 0,
            tickLength: 0,
            title: {
              text: null
            }
          },

          yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
              text: 'Open Errors'
            },
            gridLineDashStyle: 'Dash'
          },

          legend: {
            enabled: false
          },

          tooltip: {
            useHTML: true,
            headerFormat: '',
            pointFormat:
              '<b>{point.category}</b><br/>Open Errors: <b>{point.y}</b>'
          },

          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function () {
                    self.onErrorAgeClick(
                      this.category as string,
                      this.y as number
                    );
                  }
                }
              },
              animation: {
                duration: 1000,
                easing: 'easeOutExpo'
              },
            },
            bar: {
              borderRadius: 6,
              pointPadding: 0.18,
              groupPadding: 0.08,
              dataLabels: {
                enabled: true,
                style: {
                  fontWeight: '600'
                }
              }
            }
          },

          series: [{
            type: 'bar',
            name: 'Open Errors',
            data: errorAge.map(x => ({
              y: Number(x.totalErrors),

              color: this.errorAgeView === 'day'
                ? (
                  x.errorAge === '0-1 Day' ? '#22c55e' :
                    x.errorAge === '1-3 Days' ? '#eab308' :
                      x.errorAge === '3-7 Days' ? '#f97316' :
                        x.errorAge === '7-15 Days' ? '#ef4444' :
                          '#7c3aed'
                )
                : (
                  // Month view colors
                  x.errorAge === '0-1 Month' ? '#22c55e' :
                    x.errorAge === '1-3 Months' ? '#eab308' :
                      x.errorAge === '3-6 Months' ? '#f97316' :
                        x.errorAge === '6-12 Months' ? '#ef4444' :
                          '#7c3aed'
                )
            }))
          }]
        };
        this.chartOptions = {
          chart: { type: 'line' },
          title: { text: '' },
          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          credits: { enabled: false },
          xAxis: {
            categories: trend.map(x => x.day)
          },
          yAxis: {
            title: { text: 'Total Errors' },
            allowDecimals: false
          },
          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function () {
                    self.onWeeklyTrendClick(
                      this.category as string,
                      this.y as number
                    );
                  }
                }
              }
            },

            line: {
              marker: {
                enabled: true
              }
            }
          },

          series: [{
            type: 'line',
            name: 'Errors',
            color: '#dc3545',
            data: trend.map(x => Number(x.totalErrors))
          }]
        };

        this.productChartOptions = {
          chart: { type: 'column' },
          title: { text: '' },
          credits: { enabled: false },
          xAxis: {
            categories: products.map(x => x.productinitial),
            title: { text: 'Products' }
          },
          yAxis: {
            min: 0,
            allowDecimals: false,
            title: { text: 'Errors' }
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              dataLabels: {
                enabled: true
              }
            }
          },
          series: [
            {
              type: 'column',
              name: 'Open',
              color: '#dc3545',
              data: products.map(x => Number(x.openLogs))
            },
            {
              type: 'column',
              name: 'Closed',
              color: '#28a745',
              data: products.map(x => Number(x.closedLogs))
            }
          ]
        };
        this.statusChartOptions = {
          chart: {
            type: 'pie'
          },

          title: {
            text: ''
          },

          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '<b>{point.y}</b> errors ({point.percentage:.1f}%)'
          },

          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y}'
              }
            }
          },

          series: [{
            type: 'pie',
            name: 'Errors',
            data: [
              {
                name: 'Open',
                y: Number(status.openLogs),
                color: '#dc3545'
              },
              {
                name: 'Closed',
                y: Number(status.closedLogs),
                color: '#28a745'
              }
            ]
          }]
        };
        this.openLogsByProduct = {
          chart: {
            type: 'pie'
          },

          title: {
            text: ''
          },

          credits: {
            enabled: false
          },

          tooltip: {
            pointFormat: '<b>{point.y}</b> Open errors ({point.percentage:.1f}%)'
          },
          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal',
            itemStyle: {
              cursor: 'pointer',
              fontWeight: '500'
            }
          },
          plotOptions: {
            pie: {
              showInLegend: true,

              dataLabels: {
                enabled: true,
                format: '{point.name}<br><b>{point.y}</b>'
              },

              cursor: 'pointer',

              point: {
                events: {
                  click: function () {
                    self.onOpenLogsByProductClick(
                      this.name as string,
                      this.y as number
                    );
                  }
                }
              }
            }
          },

          series: [{
            type: 'pie',
            name: 'Open Errors',
            data: openErrorsByProduct.map(x => ({
              name: x.productinitial,
              y: Number(x.errorCount)
            }))
          }]
        };
        const dayMap = {
          Monday: 0,
          Tuesday: 1,
          Wednesday: 2,
          Thursday: 3,
          Friday: 4,
          Saturday: 5,
          Sunday: 6
        };

        const heatSeries = heatData.map(x => [
          dayMap[x.day],
          Number(x.hour),
          Number(x.totalErrors)
        ]);

        this.heatMapOptions = {
          chart: {
            type: 'heatmap'
          },

          title: {
            text: ''
          },

          credits: {
            enabled: false
          },
          tooltip: {
            useHTML: true,
            backgroundColor: '#ffffff',
            borderColor: '#dcdcdc',
            borderRadius: 8,
            shadow: true,
            style: {
              color: '#333333',
              fontSize: '13px'
            },
            formatter: function () {
              return `
                <div style="padding:6px">
                  <b>Day:</b> ${this.series.xAxis.categories[this.point.x]}<br/>
                  <b>Hour:</b> ${this.point.y}:00<br/>
                  <b>Total Errors:</b> <span style="color:#dc3545;font-weight:600">${this.point.value}</span>
                </div>
              `;
            }
          },

          xAxis: {
            categories: [
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
              'Sunday'
            ]
          },

          yAxis: {
            categories: Array.from({ length: 24 }, (_, i) => i.toString()),
            title: {
              text: 'Hour'
            }
          },

          colorAxis: {
            min: 0,
            minColor: '#e8f5e9',
            maxColor: '#dc3545'
          },
          plotOptions: {
            series: {
              cursor: 'pointer',

              point: {
                events: {
                  click: function () {
                    self.onHeatMapClick(
                      this.x as number,
                      this.y as number
                    );
                  }
                }
              }
            }
          },

          series: [{
            type: 'heatmap',
            data: heatSeries,
            borderWidth: 1,
            dataLabels: {
              enabled: true
            }
          }]
        };

        this.dailyTrendOptions = {
          chart: {
            type: 'line'
          },

          title: {
            text: ''
          },

          credits: {
            enabled: false
          },

          xAxis: {
            categories: dailyTrend.map(x => x.day)
          },

          yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
              text: 'Logs'
            }
          },

          tooltip: {
            shared: true
          },

          plotOptions: {
            line: {
              marker: {
                enabled: true
              }
            }
          },

          series: [
            {
              type: 'line',
              name: 'Open',
              color: '#dc3545',
              data: dailyTrend.map(x => Number(x.openLogs))
            },
            {
              type: 'line',
              name: 'Closed',
              color: '#28a745',
              data: dailyTrend.map(x => Number(x.closedLogs))
            }
          ]
        };

      }
    });

  }

  hasFilters(): boolean {
    return !!(
      this.selectedProduct ||
      this.selectedOrganisation ||
      this.selectedLogStatus ||
      (this.filtersData['tfromdate'] && this.filtersData['ttodate'])
    );
  }

  getSelectedProductName(): string {
    return this.filterProductData.find(
      x => x.productId == this.selectedProduct
    )?.productinitial || '';
  }

  getSelectedOrganisationName(): string {
    return this.filterOrgData.find(
      x => x.orgId == this.selectedOrganisation
    )?.orgname || '';
  }

  getSelectedStatusName(): string {
    switch (this.selectedLogStatus) {
      case '0': return 'Open';
      case '1': return 'Closed';
      default: return 'All';
    }
  }
  weekTrendOffset = 0;
  weekTrendRange = '';

  previousTrendWeek() {
    this.weekTrendOffset--;
    this.updateTrendWeekRange();
  }

  nextTrendWeek() {
    if (this.weekTrendOffset < 0) {
      this.weekTrendOffset++;
      this.updateTrendWeekRange();
    }
  }

  updateTrendWeekRange(reloadChart = true) {

    const start = moment()
      .startOf('isoWeek')
      .add(this.weekTrendOffset, 'weeks');

    const end = moment(start).add(6, 'days');

    this.weekTrendRange =
      `${start.format('DD MMM YYYY')} - ${end.format('DD MMM YYYY')}`;

    if (reloadChart) {
      this.reloadErrorTrend(
        start.format('YYYY-MM-DD'),
        end.format('YYYY-MM-DD')
      );
    }
  }

  reloadErrorTrend(fromDate: string, toDate: string) {

    const payload: any = {
      fromDate,
      toDate,
      chartRequest: 'errorTrend'
    };

    if (this.selectedProduct) {
      payload.productId = this.selectedProduct;
    }

    if (this.selectedOrganisation) {
      payload.orgId = this.selectedOrganisation;
    }

    if (this.selectedLogStatus != null &&
      this.selectedLogStatus !== '') {
      payload.logStatus = this.selectedLogStatus;
    }

    this.appLogService.requestChartReload(payload).subscribe({

      next: (res: any) => {

        const trend = res.errorTrend;

        this.chartOptions = {
          chart: {
            type: 'line'
          },

          title: {
            text: ''
          },

          credits: {
            enabled: false
          },

          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom'
          },

          xAxis: {
            categories: trend.map(x => x.day)
          },

          yAxis: {
            title: {
              text: 'Total Errors'
            },
            allowDecimals: false
          },

          tooltip: {
            shared: true
          },

          plotOptions: {
            line: {
              marker: {
                enabled: true
              }
            }
          },

          series: [{
            type: 'line',
            name: 'Errors',
            color: '#dc3545',
            data: trend.map(x => Number(x.totalErrors))
          }]
        };

      }

    });

  }


  weekOffset = 0;
  weekRange = '';

  previousWeek() {
    this.weekOffset--;
    this.updateWeekRange();
  }

  nextWeek() {
    if (this.weekOffset < 0) {
      this.weekOffset++;
      this.updateWeekRange();
    }
  }

  updateWeekRange(reloadChart = true) {
    const start = moment()
      .startOf('isoWeek')
      .add(this.weekOffset, 'weeks');

    const end = moment(start).add(6, 'days');

    this.weekRange =
      `${start.format('DD MMM YYYY')} - ${end.format('DD MMM YYYY')}`;

    if (reloadChart) {
      this.reloadHeatMap(
        start.format('YYYY-MM-DD'),
        end.format('YYYY-MM-DD')
      );
    }
  }

  reloadHeatMap(fromDate: string, toDate: string) {

    const payload: any = {
      fromDate,
      toDate
    };

    if (this.selectedProduct) {
      payload.productId = this.selectedProduct;
    }

    if (this.selectedOrganisation) {
      payload.orgId = this.selectedOrganisation;
    }

    if (this.selectedLogStatus != null && this.selectedLogStatus !== '') {
      payload.logStatus = this.selectedLogStatus;
    }

    payload.chartRequest = "heatMap";

    this.appLogService.requestChartReload(payload).subscribe({
      next: (res: any) => {

        const heatData = res.sevenDayHeatMap;

        const dayMap = {
          Monday: 0,
          Tuesday: 1,
          Wednesday: 2,
          Thursday: 3,
          Friday: 4,
          Saturday: 5,
          Sunday: 6
        };

        const heatSeries = heatData.map(x => [
          dayMap[x.day],
          Number(x.hour),
          Number(x.totalErrors)
        ]);

        this.heatMapOptions = {
          ...this.heatMapOptions,
          series: [{
            type: 'heatmap',
            data: heatSeries,
            borderWidth: 1,
            dataLabels: {
              enabled: true
            }
          }]
        };
      }
    });
  }
  getErrorStreakClass(): string {

    const hours = this.getStreakHours();

    if (hours < 24) return 'streak-critical';
    if (hours < 72) return 'streak-warning';
    if (hours < 168) return 'streak-caution';
    if (hours < 336) return 'streak-good';

    return 'streak-excellent';
  }

  getErrorStreakLabel(): string {

    const hours = this.getStreakHours();

    if (hours < 24) return 'Critical';      // Less than 1 day
    if (hours < 72) return 'Warning';       // 1-3 days
    if (hours < 168) return 'Stable';       // 3-7 days
    if (hours < 336) return 'Healthy';      // 1-2 weeks
    return 'Excellent';
  }

  getOccurrenceClass(count: number): string {
    if (count >= 50) return 'critical';
    if (count >= 20) return 'high';
    if (count >= 10) return 'medium';
    return 'low';
  }

  private getStreakHours(): number {

    const streak = this.summaryCards?.errorFreeStreak;

    if (!streak) return 0;

    return Number(streak.split(':')[0]);
  }

  errorAgeView: 'day' | 'month' = 'day';

  changeErrorAgeView(view: 'day' | 'month') {
    if (this.errorAgeView === view) {
      return;
    }
    const self = this;

    const payload: any = {
      chartRequest: 'errorAge',
      mode: view
    };

    if (this.selectedProduct) {
      payload.productId = this.selectedProduct;
    }

    if (this.selectedOrganisation) {
      payload.orgId = this.selectedOrganisation;
    }
    this.errorAgeView = view;
    this.appLogService.requestChartReload(payload).subscribe({

      next: (res: any) => {
        const errorAge = res.errorAge;
        this.errorAgeChartOptions = {
          chart: {
            type: 'bar',
            height: 330
          },

          title: {
            text: ''
          },

          credits: {
            enabled: false
          },

          xAxis: {
            categories: errorAge.map(x => x.errorAge),
            lineWidth: 0,
            tickLength: 0,
            title: {
              text: null
            }
          },

          yAxis: {
            min: 0,
            allowDecimals: false,
            title: {
              text: 'Open Errors'
            },
            gridLineDashStyle: 'Dash'
          },

          legend: {
            enabled: false
          },

          tooltip: {
            useHTML: true,
            headerFormat: '',
            pointFormat:
              '<b>{point.category}</b><br/>Open Errors: <b>{point.y}</b>'
          },

          plotOptions: {
            series: {
              cursor: 'pointer',
              point: {
                events: {
                  click: function () {
                    self.onErrorAgeClick(
                      this.category as string,
                      this.y as number
                    );
                  }
                }
              },
              animation: {
                duration: 1000,
                easing: 'easeOutExpo'
              },
            },
            bar: {
              borderRadius: 6,
              pointPadding: 0.18,
              groupPadding: 0.08,
              dataLabels: {
                enabled: true,
                style: {
                  fontWeight: '600'
                }
              }
            }
          },

          series: [{
            type: 'bar',
            name: 'Open Errors',
            data: errorAge.map(x => ({
              y: Number(x.totalErrors),

              color: this.errorAgeView === 'day'
                ? (
                  x.errorAge === '0-1 Day' ? '#22c55e' :
                    x.errorAge === '1-3 Days' ? '#eab308' :
                      x.errorAge === '3-7 Days' ? '#f97316' :
                        x.errorAge === '7-15 Days' ? '#ef4444' :
                          '#7c3aed'
                )
                : (
                  // Month view colors
                  x.errorAge === '0-1 Month' ? '#22c55e' :
                    x.errorAge === '1-3 Months' ? '#eab308' :
                      x.errorAge === '3-6 Months' ? '#f97316' :
                        x.errorAge === '6-12 Months' ? '#ef4444' :
                          '#7c3aed'
                )
            }))
          }]
        };
      }
    });
  }

  onErrorAgeClick(age: string, count: number) {
    const payload = {
      productId: this.selectedProduct,
      orgId: this.selectedOrganisation,
      logStatus: this.selectedLogStatus,
      errorAge: age
    };
    this.show('Error Age Data', payload);
  }

  getRandomInsight() {
    this.appLogService.getRandomInsight().subscribe({
      next: (res: any) => {
        this.randomInsight = res;
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  onOpenLogsByProductClick(product: string, count: number) {
    const payload: any = {
      productId: product,
      orgId: this.selectedOrganisation
    };

    if (this.filtersData['tfromdate']) {
      payload.fromDate = this.filtersData['tfromdate'];
    }

    if (this.filtersData['ttodate']) {
      payload.toDate = this.filtersData['ttodate'];
    }

    this.show('Open Errors by Product', payload);
  }

  onWeeklyTrendClick(day: string, count: number) {
    this.selectedDate = moment(day, 'DD-MMM-YY').format('YYYY-MM-DD');
    const payload: any = {
      productId: this.selectedProduct,
      orgId: this.selectedOrganisation,
      selectedDate: this.selectedDate
    };


    this.show('Weekly Trend', payload);
  }


  openEmailConfigModal(logId: any, status: any) {
    this.gettoken();

    this.selectedLogId = logId;
    this.selectedTechUsers = [];

    if (status == 0) {
      this.allowSendingEmail = 1;
      this.appLogService.getTechUsers().subscribe({
        next: (response: any[]) => {
          this.techUsers = response || [];
        },
        error: (error) => {
          this.techUsers = [];
        }
      });
    }
    if (status == 1) {
      this.allowSendingEmail = 0;
    }

    this.showEmailConfig = true;


    this.appLogService.getReminderHistory(logId).subscribe({
      next: (response: any) => {
        this.reminderData = response || [];
      },
      error: (error) => {
        console.error('Error loading reminder history:', error);
        this.reminderData = [];
      }
    });
  }

  sendErrorReminder() {
    if (this.isSendingReminder) {
      return;
    }
    this.isSendingReminder = true;
    const payload = {
      selectedLogId: this.selectedLogId,
      selectedTechUsers: this.selectedTechUsers,
      csrftoken: this.CSRFToken
    };
    this.appLogService.remindUser(payload).subscribe({
      next: (response: any) => {
        const code = response?.response;

        switch (code) {
          case '1':
            Swal.fire('Reminder sent successfully!', '', 'success');
            this.showEmailConfig = false;
            this.loadActivityFeed();
            this.getgriddata();
            break;
          case '0':
            Swal.fire('Mail Flag is disabled for the product!', '', 'warning');
            this.showEmailConfig = false;
            break;
          default:
            Swal.fire('Error', 'An unexpected error occurred.', 'error');
            break;
        }
        this.showEmailConfig = false;
        this.isSendingReminder = false;
      },
      error: (error) => {
        this.showEmailConfig = false;
        this.isSendingReminder = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.error?.response || 'An unexpected error occurred.',
          footer: `Error status: ${error.status}`
        });
      }
    });

  }

  onHeatMapClick(dayIndex: number, hour: number) {
    const start = moment().startOf('isoWeek').add(this.weekOffset, 'weeks');
    const clickedDateTime = moment(start).add(dayIndex, 'days').hour(hour);

    this.selectedDate = clickedDateTime.format('YYYY-MM-DD');
    this.selectedHour = hour;

    const payload = {
      date: this.selectedDate,
      hour: this.selectedHour,
      productId: this.selectedProduct,
      orgId: this.selectedOrganisation
    };

    this.show('Heat Map', payload);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  loadActivityFeed(): void {

    this.activityFeedLoading = true;

    const payload: any = {};

    if (this.activityFeedDate) {
      payload.activityDate = this.formatDate(this.activityFeedDate);
    }

    if (this.activityFilter && this.activityFilter !== 'ALL') {
      payload.activityFilter = this.activityFilter;
    }

    this.appLogService.getActivityFeed(payload).subscribe({
      next: (response: ActivityFeedItem[]) => {
        this.activityFeed = response || [];
        this.activityFeedLoading = false;
      },
      error: (error) => {
        this.activityFeed = [];
        this.activityFeedLoading = false;
      }
    });
  }

  getActivityIcon(activity: ActivityFeedItem): string {
    switch (activity.activityType) {
      case 'ERROR':
        return 'fa fa-exclamation-circle';
      case 'CLOSED':
        return 'fa fa-check-circle';
      case 'REMINDER':
        return 'fa fa-envelope';
      default:
        return 'fa fa-info-circle';
    }
  }

  getActivityClass(activity: ActivityFeedItem): string {
    switch (activity.activityType) {
      case 'ERROR':
        return 'feed-error';
      case 'CLOSED':
        return 'feed-closed';
      case 'REMINDER':
        return 'feed-reminder';

      default:
        return 'feed-info';
    }
  }
  getUserInitials(name: string): string {
    if (!name) {
      return '?';
    }
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (
      parts[0].charAt(0) +
      parts[parts.length - 1].charAt(0)
    ).toUpperCase();
  }

  onActivityClick(logId: any, activityType: string,isClosed: any): void {
    if (activityType == "ERROR") {
      if(isClosed == 1)
      { 
        this.onlyView = true;
        this.isClose = false;
        this.viewClosureData = false;
      }
      this.show('Close Error Log', { id: logId,isClosed: isClosed });
    }
    if (activityType === 'CLOSED') {
      this.show('Closure Data', {
        id: logId
      });
    }
    if (activityType === 'REMINDER') {
      this.openEmailConfigModal(logId, 1);
    }
  } 

  setActivityFilter(filter: string): void {
    this.activityFilter = filter;
    this.loadActivityFeed();
  }
   
}


export class Filterreq {
  fromdate: string = '';
  todate: string = '';
  page = 1;
  size = 10;
}

export interface ActivityFeedItem {
  logId: number;
  userName: string;
  userEmail: string;
  organisation: string;
  product: string;
  page: string;
  methodName: string;
  remarks: string;
  activityType: 'ERROR' | 'CLOSED' | 'REMINDER';
  activityText: string;
  sortTime: string;
  activityTime: string;
  message: string;

  isClosed: number;
  reminders: number;
}
